import { render } from "./DashboardTodo.vue?vue&type=template&id=d18e957e&scoped=true&ts=true"
import script from "./DashboardTodo.vue?vue&type=script&lang=ts"
export * from "./DashboardTodo.vue?vue&type=script&lang=ts"

import "./DashboardTodo.vue?vue&type=style&index=0&id=d18e957e&scoped=true&lang=scss"

import exportComponent from "/builds/maqqie/maqqie-client-portal/clientportal-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d18e957e"]])

export default __exports__